// src/hooks/useFlightSearch.jsx
import { useQuery } from "@tanstack/react-query";
import apiService from "../../Common/Configurations/APIService";
import config from "../../Common/Configurations/APIConfig";

export const useFlightSearch = (searchQuery) => {
  const queryFn = async () => {
    if (!searchQuery || Object.keys(searchQuery).length === 0) return[];

    console.log("API Request - Flight Search Query:", searchQuery);
    const result = await apiService.post(config.SEARCHFLIGHTS, searchQuery);
    console.log("API Result:", result);

    if (result && result.length > 0) {
      // Sort flights by price right here in the hook before returning to UI
      return result.map((destination) => {
        if (destination?.dcFlightLegs && Array.isArray(destination.dcFlightLegs)) {
          const sortedLegs =[...destination.dcFlightLegs].sort(
            (a, b) => (a.totalPrice || 0) - (b.totalPrice || 0)
          );

          return {
            ...destination,
            dcFlightLegs: sortedLegs,
          };
        }
        return destination;
      });
    }
    
    return[];
  };

  return useQuery({
    // Using JSON.stringify ensures React Query registers object changes properly
    queryKey: ["flight-search", JSON.stringify(searchQuery)],
    queryFn,
    // Only execute if searchQuery exists and has keys
    enabled: !!searchQuery && Object.keys(searchQuery).length > 0,
    staleTime: 1000 * 60 * 15, // Cache results for 15 minutes
    refetchOnWindowFocus: false,
    retry: 1,
  });
};